module.exports = __webpack_public_path__ + "static/media/tech-video-4.ceba7148.png";